import { HttpService } from "../http";

export class DeptCategoryService extends HttpService {
  fetchCategories = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/departments/public`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addDeptCategory = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/departments`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addSubCategory = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/departments/bulk`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCategory = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/departments/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteCategory = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/departments/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
